import Auth from '../api/Auth';
import Tv from '../api/tv';


// initial state
const state = {
    firstLoad: true,
    username: "",
    isLogged: false,
    sessionId: "",
    firstName: "",
    lastName: "",
    isLoading: false,
    errorMessage : "",
    tvTerritorio: {}
}
const getters = {
    fullName: function() {
        return state.firstName + " " + state.lastName;
    }
}
const actions = {
    login({ commit },[user,cb]) {
        //Check Login  
        
        commit('setLoading',{loading : true});  
        let auth = new Auth();        
        auth.login(user.username,user.password,auth => {
            commit('setLoading',{loading : false});  
            commit('setLogin',auth);
            
            if(cb) cb(auth.isLogged);
            if(!auth.isLogged) {
                commit('setErrorMessage',{errorMessage : "utente o password errati"});  
            }
        });
    },
    logout({commit}) {
        let auth = new Auth();
        auth.logout(auth => {
            commit('setLogout',auth);
        });
    },
    checkLogin({commit},cb) {
        let auth = new Auth();
        auth.checkLogin(auth => {
            if(auth.isLogged) {
                commit('setLogin',auth);
                if(cb) cb(auth.isLogged);                
            } else {
                commit('setLogout',{result: false});
                if(cb) cb(false);
            }

        });
    },
    loadTvTerritorio({commit}) {
        let tmp = new Tv();
        /*tmp.getTvTerritorio( tv => {
            commit('setTvTerritorio', tv);
        });*/
        let p = tmp.getTvTerritorio();
        //console.log('PROVA')
        p.then(tv => {
            //console.log("PROVA",tv.data);
            commit('setTvTerritorio', tv.data);
        });
    }
}
const mutations = {
    setLogin(state, auth) {
        state.firstLoad = false;
        state.username = auth.username;
        state.isLogged = auth.isLogged;
        state.sessionId = auth.sessionId;
        state.firstName = auth.firstName;
        state.lastName = auth.lastName;
        state.errorMessage = "";
    },
    setLogout(state,logout) {
        if(logout.result) {
            state.username = "";
            state.isLogged = false;
            state.sessionId = "";
            state.firstName = "";
            state.lastName = "";
            state.errorMessage = "";
        }        
    },
    setLoading(state,payload) {
        state.isLoading = payload.loading;            
    },
    setErrorMessage(state,payload) {
        state.errorMessage = payload.errorMessage;            
    },
    setTvTerritorio(state, payload) {
        //console.log("commit setTvTerritorio", payload);
        state.tvTerritorio = payload;
        state = {
            ...state,            
        };        
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
  